import React from 'react'
import PropTypes from 'prop-types'
/* eslint-disable import/no-extraneous-dependencies */
import { List, AutoSizer } from 'react-virtualized'
/* eslint-enable import/no-extraneous-dependencies */
import virtualListPropType from './virtual-list-prop-type'

const propTypes = {
    childDecorator: PropTypes.func,
    settings: virtualListPropType.isRequired
}

const defaultProps = {
    childDecorator: defaultChildDecorator
}

/**
 * Generates a virtual list for the given children
 * @param {Object||Array}   children        - react children (usually an array of react/dom-elements)
 * @param {VirtualList}     settings        - settings to control the virtual list behavior (especially row height)
 * @param {Function}        [childDecorator=defaultChildDecorator]  - should return a "decorated" copy of a given child
 */
function VirtualList({ childDecorator, children, settings }) {
    const childrenArray = Array.isArray(children) ? Array.from(children) : React.Children.toArray(children)
    return (
        <AutoSizer>
            {({ height, width }) => (
                <List
                    {...{ height, width }}
                    rowHeight={settings.rowHeight}
                    overscanRowCount={settings.rowOverscan || 10}
                    rowCount={childrenArray.length}
                    rowRenderer={getRowRenderer(childrenArray, childDecorator)}
                    scrollToIndex={settings.scrollPosition}
                />
            )}
        </AutoSizer>
    )
}

VirtualList.propTypes = propTypes
VirtualList.defaultProps = defaultProps

export default VirtualList

function defaultChildDecorator(child) {
    return <div>{React.cloneElement(child, child.props)}</div>
}

function getRowRenderer(children, childDecorator = defaultChildDecorator) {
    return ({ index, key, style }) => {
        const child = childDecorator(children[index])
        const childProps = Object.assign({}, child.props, { key, style })
        return React.cloneElement(child, childProps)
    }
}
